export default __webpack_public_path__ + "static/media/Florence.4cb304a7.jpg";